import React, { useState } from 'react';
import { RefreshCw, Download, Upload } from 'lucide-react';

const SheetsSyncWidget = () => {
  const [syncing, setSyncing] = useState(false);

  const handleSync = () => {
    setSyncing(true);
    setTimeout(() => {
      setSyncing(false);
      alert('Sync completed!');
    }, 2000);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-3">
        <button className="flex flex-col items-center space-y-2 p-4 border rounded-lg hover:bg-gray-50">
          <Download className="w-6 h-6 text-blue-600" />
          <span className="text-sm">Import</span>
        </button>
        <button className="flex flex-col items-center space-y-2 p-4 border rounded-lg hover:bg-gray-50">
          <Upload className="w-6 h-6 text-green-600" />
          <span className="text-sm">Export</span>
        </button>
        <button
          onClick={handleSync}
          disabled={syncing}
          className="flex flex-col items-center space-y-2 p-4 border rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          <RefreshCw className={`w-6 h-6 text-purple-600 ${syncing ? 'animate-spin' : ''}`} />
          <span className="text-sm">Sync</span>
        </button>
      </div>

      <div className="p-3 bg-gray-50 rounded-lg">
        <p className="text-sm text-gray-600">Last synced: Never</p>
      </div>
    </div>
  );
};

export default SheetsSyncWidget;